export default "__VITE_ASSET__5b04b983__"